export function SignUpInviteExtend() {
	return <p>EXTEND</p>;
}
